import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class EventEvaluationService extends BaseService {

  constructor(
    protected override http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/evaluations`);
  }

  saveAnswers(
    appearance: string,
    payload: { answers: Record<string, any> },
    urlParams: { company_id: string; event_id: string },
  ): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams);
    return this.http.post<any>(`${url}/${encodeURIComponent(appearance)}`, payload);
  }
}
